"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHorizontalStrength = createHorizontalStrength;
exports.createVerticalStrength = createVerticalStrength;
exports["default"] = createScrollingComponent;
exports.defaultVerticalStrength = exports.defaultHorizontalStrength = void 0;
exports.useDndScrolling = useDndScrolling;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _defaults = _interopRequireDefault(require("defaults"));

var _reactDnd = require("react-dnd");

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _util = require("./util.js");

var _ScrollingMonitor = _interopRequireDefault(require("./ScrollingMonitor.js"));

var _excluded = ["strengthMultiplier", "verticalStrength", "horizontalStrength", "onScrollChange"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DEFAULT_BUFFER = 150;

var getDisplayName = function getDisplayName(PassedComponent) {
  return PassedComponent.displayName || PassedComponent.name || (typeof PassedComponent === 'string' && PassedComponent.length > 0 ? PassedComponent : 'Unknown');
};

function createHorizontalStrength(_buffer) {
  return function defaultHorizontalStrength(_ref, point) {
    var x = _ref.x,
        w = _ref.w,
        y = _ref.y,
        h = _ref.h;
    var buffer = Math.min(w / 2, _buffer);
    var inRange = point.x >= x && point.x <= x + w;
    var inBox = inRange && point.y >= y && point.y <= y + h;

    if (inBox) {
      if (point.x < x + buffer) {
        return (point.x - x - buffer) / buffer;
      } else if (point.x > x + w - buffer) {
        return -(x + w - point.x - buffer) / buffer;
      }
    }

    return 0;
  };
}

function createVerticalStrength(_buffer) {
  return function defaultVerticalStrength(_ref2, point) {
    var y = _ref2.y,
        h = _ref2.h,
        x = _ref2.x,
        w = _ref2.w;
    var buffer = Math.min(h / 2, _buffer);
    var inRange = point.y >= y && point.y <= y + h;
    var inBox = inRange && point.x >= x && point.x <= x + w;

    if (inBox) {
      if (point.y < y + buffer) {
        return (point.y - y - buffer) / buffer;
      } else if (point.y > y + h - buffer) {
        return -(y + h - point.y - buffer) / buffer;
      }
    }

    return 0;
  };
}

var defaultHorizontalStrength = createHorizontalStrength(DEFAULT_BUFFER);
exports.defaultHorizontalStrength = defaultHorizontalStrength;
var defaultVerticalStrength = createVerticalStrength(DEFAULT_BUFFER);
exports.defaultVerticalStrength = defaultVerticalStrength;
var defaultOptions = {
  onScrollChange: _util.noop,
  verticalStrength: defaultVerticalStrength,
  horizontalStrength: defaultHorizontalStrength,
  strengthMultiplier: 30
};

function useDndScrolling(componentRef, passedOptions) {
  var _useContext = (0, _react.useContext)(_reactDnd.DndContext),
      dragDropManager = _useContext.dragDropManager;

  if (!dragDropManager) {
    throw new Error('Unable to get dragDropManager from context. Wrap this in <DndProvider>.');
  }

  (0, _react.useEffect)(function () {
    if (!componentRef.current) {
      return function () {};
    }

    var options = (0, _defaults["default"])(passedOptions, defaultOptions);
    var monitor = new _ScrollingMonitor["default"](dragDropManager, componentRef.current, options);
    monitor.start();
    return function () {
      monitor.stop();
    };
  }, [componentRef, dragDropManager, passedOptions]);
}

function createScrollingComponent(WrappedComponent) {
  function ScrollingComponent(_ref3) {
    var strengthMultiplier = _ref3.strengthMultiplier,
        verticalStrength = _ref3.verticalStrength,
        horizontalStrength = _ref3.horizontalStrength,
        onScrollChange = _ref3.onScrollChange,
        passedProps = _objectWithoutProperties(_ref3, _excluded);

    var ref = (0, _react.useRef)(null);
    useDndScrolling(ref, {
      strengthMultiplier: strengthMultiplier,
      verticalStrength: verticalStrength,
      horizontalStrength: horizontalStrength,
      onScrollChange: onScrollChange
    });
    return (
      /*#__PURE__*/
      _react["default"].createElement(WrappedComponent, _extends({}, passedProps, {
        ref: ref
      }))
    );
  }

  ScrollingComponent.displayName = "Scrolling(".concat(getDisplayName(WrappedComponent), ")");
  ScrollingComponent.propTypes = {
    onScrollChange: _propTypes["default"].func,
    verticalStrength: _propTypes["default"].func,
    horizontalStrength: _propTypes["default"].func,
    strengthMultiplier: _propTypes["default"].number
  };
  ScrollingComponent.defaultProps = defaultOptions;
  return (0, _hoistNonReactStatics["default"])(ScrollingComponent, WrappedComponent);
}